import Api, {
  baseURL,
  requestOptionsDELETE,
  requestOptionsDELETEWithArrayBody,
  requestOptionsGET,
  requestOptionsPOSTwithFormData,
  requestOptionsPUTWithBody,
  requestOptionsPUTWithArrayBody
} from '../api';
import newFetch, { fetchBlob } from '../utils/newFetch';
import LocalStorageHandler from '@/handlers/LocalStorageHandler';

const state = {
  historic: [],
  justificationsTypes: [],
  justificationsById: [],
  status: [],
  selectedCheckox: [],
  nfeByStatus: []
};

const getters = {
  getHistorics: (state) => state.historic,
  getJustificationsTypes: (state) => state.justificationsTypes,
  getJustificationsById: (state) => state.justificationsById,
  getStatus: (state) => state.status,
  getNfeByStatus: (state) => state.nfeByStatus,

  getSelectedChecbox: (state) => {
    const selected = state.selectedCheckox;
    if (selected.length === 0) {
      const hierarchies = LocalStorageHandler.getReceiptsHierarchies();
      // LocalStorageHandler.removeReceiptsHierarchies();
      return hierarchies;
    }
    return selected;
  }
};

const mutations = {
  setHistoric(state, payload) {
    state.historic = payload;
  },
  setJustificationsTypes(state, payload) {
    state.justificationsTypes = payload;
  },
  setJustificationsById(state, payload) {
    state.justificationsById = payload;
  },
  setStatus(state, payload) {
    state.status = payload;
  },
  setSelectedCheckbox(state, payload) {
    LocalStorageHandler.setReceiptsHierarchies(payload);
    state.selectedCheckox = payload;
  },
  setNfeByStatus(state, payload) {
    state.nfeByStatus = payload;
  }
};

const actions = {
  fetchHistoric(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getNfeById + id + '/Histories', requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
          context.commit('setHistoric', data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchJustificationsById(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getJustificationsNfe + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
          context.commit('setJustificationsById', data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchJustification(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getJustificationsNfe + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchNfeAttachmentsById(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getNfeById + id + '/NfeAttachments',
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
          context.commit('setJustificationsById', data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchJustificationsTypes(context) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getJustificationsTypesNfe, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
          context.commit('setJustificationsTypes', data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchStatus(context, role) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getStatusByRoles + '?statusByRoles=' + role,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
          context.commit('setStatus', data);
        })
        .catch((err) => reject(err));
    });
  },
  getNfesByStatusIdForManagement(context, statusId) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getNfesByStatusIdForManagement + '?statusId=' + statusId,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
          context.commit('setNfeByStatus', data);
        })
        .catch((err) => reject(err));
    });
  },
  getNfesByStatusIdForManagementGivBack(context) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getNfesByStatusIdForManagement + '?statusId=8&statusId=15',
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
          context.commit('setNfeByStatus', data);
        })
        .catch((err) => reject(err));
    });
  },
  changeStatus(_, params = {}) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.statusManagerBKO, requestOptionsPUTWithBody(localStorage.getItem('accessToken'), params))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createNfeAttachments(_, params = {}) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getNfe + '?nfeId=' + params.id,
        requestOptionsPOSTwithFormData(localStorage.getItem('accessToken'), params.body)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchDownloadNfeAttachmentsById(_, id) {
    return new Promise((resolve, reject) => {
      fetchBlob(
        baseURL + Api.getNfe + 'NfeAttachments/' + id + '/Download/',
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createReceiptNfe(_, params = {}) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.receiptNfe + 'AddOrUpdateReceiptNfe/' + '?nfeId=' + params.id,
        requestOptionsPOSTwithFormData(localStorage.getItem('accessToken'), params.body)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchReceiptNfeById(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.receiptNfe + 'GetReceiptsByNfesId/' + '?nfesId=' + id,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
          context.commit('setJustificationsById', data);
        })
        .catch((err) => reject(err));
    });
  },
  getSrcImage(context, endpoint) {
    return new Promise((resolve, reject) => {
      fetchBlob(endpoint, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  deleteNfeAttachmentById(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getNfe + id, requestOptionsDELETE(localStorage.getItem('accessToken')))
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  appovreNfeReceipt(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.approveReceiptNfe,
        requestOptionsPUTWithArrayBody(localStorage.getItem('accessToken'), [id])
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  deleteNfeReceipt(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.deleteReceiptNfe,
        requestOptionsDELETEWithArrayBody(localStorage.getItem('accessToken'), Array.isArray(id) ? id : [id])
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getJustificationsAttachmentsImage(_, id) {
    return new Promise((resolve, reject) => {
      fetchBlob(
        baseURL + 'pt/api/Nfes/' + id + '/JustificationAttachment/Images',
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((response) => {
          const image = URL.createObjectURL(response);
          resolve(image);
        })
        .catch((err) => reject(err));
    });
  },
  fetchDownloadNfeJustificationsAttachmentsImage(_, id) {
    return new Promise((resolve, reject) => {
      fetchBlob(
        baseURL + 'pt/api/Nfes/' + id + '/JustificationAttachment/Images',
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getNfesByStopAndStatusesIds(_, params) {
    const { stopId, statusesIds } = params;

    let statusesParam = statusesIds.reduce((acc, cur, i) => {
      const concatSign = statusesIds.length - 1 === i ? '' : '&';
      return (acc += `statusId=${cur}${concatSign}`);
    }, '');

    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getNfesByStopAndStatusesIds + `?stopId=${stopId}&${statusesParam}`,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  updateNfesCompletionDates(_, body) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.updateNfesCompletionDates,
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), body)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  fetchNfesByStopId(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getNfesByStopId + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
